import {
  US_ASSOCIATED_STATES,
  US_DOMESTIC_COUNTRIES,
  US_MILITARY_CITIES,
  US_MILITARY_REGIONS,
} from '../constants';

type Address = {
  city: string;
  regionCode: string;
  countryCode: string;
};

/**
 * Determines if a customs form is required based on the provided addresses.
 * A customs form is required if any address is outside of the US domestic countries,
 * or if it is in a US associated state, military region, or military city.
 */
export default function requiresAddressCustomsForm(addresses: Address[]): boolean {
  return addresses.some(
    ({ city, regionCode, countryCode }) =>
      !US_DOMESTIC_COUNTRIES.includes(countryCode) ||
      US_ASSOCIATED_STATES.includes(regionCode) ||
      US_MILITARY_REGIONS.includes(regionCode) ||
      US_MILITARY_CITIES.includes(city),
  );
}
